
<!-- TODO: 逻辑处理完，需要删除 template 元素 -->
<template>
  <h1>支付宝支付完成</h1>
</template>

<script setup>

const toPage = (page) => {
  window.location.href=page
}

toPage('/personalRole')

</script>
